import axios from 'axios';

const state = () => ({
  backendValidationErrors: '',
  emptySurvey: true,
  validationTrigger: 0,
  personValidations: {},
  errorMessage: '',
  protocol: {},
});

const getters = {
  backendValidationErrors: state => {
    return state.backendValidationErrors;
  },
  emptySurvey: state => {
    return state.emptySurvey;
  },
  validationTrigger: state => {
    return state.validationTrigger;
  },
  personValidations: state => {
    return state.personValidations;
  },
  errorMessage: state => {
    return state.errorMessage;
  },
  protocol: state => {
    return state.protocol;
  },
};

const mutations = {
  backendValidationErrors(state, backendValidationErrors) {
    state.backendValidationErrors = backendValidationErrors;
  },
  emptySurvey(state, emptySurvey) {
    state.emptySurvey = emptySurvey;
  },
  validationTrigger(state, validationTrigger) {
    state.validationTrigger = validationTrigger + Date.now();
  },
  errorMessage(state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  personValidations(state, personValidations) {
    if (personValidations === 'reset') {
      state.personValidations = {};
    } else {
      let questionId = personValidations[0];
      let status = personValidations[1];
      state.personValidations[questionId] = status;
    }
  },
  protocol(state, protocol) {
    state.protocol = protocol;
  },
};

export const actions = {
  async saveQuestions(
    { commit },
    { questionData, surveys, containerId, status, protocolId, isSimplifyForm },
  ) {
    let data = {
      questionData: questionData,
      surveys: surveys,
      previousStatus: '',
      containerId: containerId,
      protocolId: protocolId,
    };
    if (data['surveys']['surveyStatus'] === 'Submitted') {
      data['surveys']['surveyId'] = null;
      data['previousStatus'] = 'submitted';
    } else if (data['surveys']['surveyStatus'] === 'Draft') {
      data['previousStatus'] = 'draft';
    } else if (data['surveys']['surveyStatus'] === 'New') {
      data['previousStatus'] = 'new';
    }
    data['surveys']['surveyStatus'] = status;
    try {
      let url = `/api/save-questions`;
      if (isSimplifyForm) {
        url = `/api/store-forms`;
      }
      return await axios.post(url, data);
    } catch (error) {
      if (error.response.status === 406) {
        commit('backendValidationErrors', error.response.data[0]);
        commit('errorMessage', 'Validation error!!');
      } else {
        commit('errorMessage', `Something went wrong while saving, code(${error.response.status})`);
      }
      console.error(error);
      return error;
    }
  },
  async checkForEmptySurvey({ commit }, { questionData }) {
    let savedValues = [];
    for (let element in questionData) {
      savedValues.push(questionData[element]['value']);
    }
    commit(
      'emptySurvey',
      savedValues.every((val, i, arr) => val === ''),
    );
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
